import { z } from 'zod';

const ComplexChild = z.object({
  id: z.string().uuid(),
  name: z.string(),
  claimNumber: z.string(),
  resourceExternalId: z.string(),
  team: z.string(),
});

const ComplexLossResource = z.object({
  id: z.string().uuid(),
  name: z.string(),
  children: z.array(ComplexChild),
});

const ComplexLossAssignment = z.object({
  id: z.string().uuid(),
  event: z.string(),
  resource: z.string(),
});

const ComplexLossEvent = z.object({
  id: z.string().uuid(),
  eventColor: z.string(),
  iconCls: z.string(),
  name: z.string(),
  startDate: z.string(),
  endDate: z.string(),
});

const ComplexLossSchema = z.object({
  resources: z.array(ComplexLossResource),
  assignments: z.array(ComplexLossAssignment),
  events: z.array(ComplexLossEvent),
});

const ComplexLossChildResponseSchema = z.object({
  resource: ComplexLossResource,
  assignments: z.array(ComplexLossAssignment),
  events: z.array(ComplexLossEvent),
});

export type ComplexLossDataResponse = z.infer<typeof ComplexLossSchema>;
export type ComplexLossChildResponseSchema = z.infer<
  typeof ComplexLossChildResponseSchema
>;
export type ComplexLossResourceSchema = z.infer<typeof ComplexLossResource>;
export type ComplexLossEventSchema = z.infer<typeof ComplexLossEvent>;
export type ComplexLossAssignmentSchema = z.infer<typeof ComplexLossAssignment>;
